import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";
import { Link } from "react-router-dom";

const Home = () => {
  let user = JSON.parse(localStorage.getItem("users"));
  let name = user?.data?.name;

  return (
    <section className="row gy-4">
      <div className="col-xxl-12">
        <h4>Welcome {name}!</h4>
        <br />
        <div className="row gy-4">
          <div className="col-xxl-3 col-sm-6">
            <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-1">
              <div className="card-body p-0">
                <Link to="/admin/gallery">
                  <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                    <div className="d-flex align-items-center gap-2">
                      <span className="mb-0 w-48-px h-48-px bg-primary-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0">
                        <Icon
                          icon="mingcute:user-follow-fill"
                          className="icon"
                        />
                      </span>
                      <div>
                        <h6 className="fw-semibold">Gallery</h6>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xxl-3 col-sm-6">
            <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-2">
              <div className="card-body p-0">
                <Link to="/admin/activity">
                  <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                    <div className="d-flex align-items-center gap-2">
                      <span className="mb-0 w-48-px h-48-px bg-success-main flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                        <Icon
                          icon="mingcute:user-follow-fill"
                          className="icon"
                        />
                      </span>
                      <div>
                        <h6 className="fw-semibold">Activities</h6>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
